<template>
  <div style="padding-bottom: 150px" class="centered">
    <div class="" style="">
      <div
        class="table-teste center"
        style="margin-left: 150px"
        v-if="getCollaborators.length > 0 && getCostCenters.length > 0"
      >
        <el-table
          :highlight-current-row="true"
          :cell-style="{ cursor: 'pointer' }"
          :header-cell-style="{ color: '#333' }"
          :default-sort="{ prop: 'name', order: 'descending' }"
          @row-click="handleRowClick"
          :data="dataTable"
          style="width: 100%"
        >
          <el-table-column label="Regras" prop="title">
            <template slot="header">
              <div>
                <div>
                  <span class="header-date">Regras</span>
                  <el-date-picker
                    v-model="rulesMonth"
                    type="month"
                    format="MM/yyyy"
                    placeholder="Selecione um mês"
                    :clearable="false"
                    :picker-options="datePickerOptions"
                    @change="newDatePeriod"
                  >
                  </el-date-picker>
                </div>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div v-else class="empty-data">
        <span class=""
          >É preciso ter colaboradores e centros de custos cadastrados para
          navegar e configurar as regras.</span
        >
      </div>
    </div>
  </div>
</template>

<style scoped>
.empty-data {
  font-size: 14px;
  left: 50%;
  top: 40%;
  margin-right: -50%;
  transform: translate(-50%, -50%);
  position: absolute;
}
</style>

<script>
import { mapActions, mapGetters } from "vuex";
import store from "../utils/store";

import rules from "../utils/rules/index";

import api from "../utils/api";

export default {
  name: "RulesList",
  data() {
    return {
      locationId: null,
      dataTable: [],
      rulesMonth: null,
      datePickerOptions: {
        disabledDate(date) {
          return date > new Date();
        },
      },
    };
  },
  computed: {
    ...mapGetters([
      "getLocationId",
      "getCollaborators",
      "getCostCenters",
      "getRulesMonth",
    ]),
  },
  async created() {
    this.updateNavCurrentIndex("6");
    this.rulesMonth = this.getRulesMonth;
    const array_teste = store.state.navItems.map((e) => {
      if (
        e.route === "/" ||
        e.route === "/upload" ||
        e.route === "/apportionmentBylocation"
      ) {
        return { ...e, disabled: false, route: "/apportionmentBylocation" };
      } else {
        return { ...e, disabled: false };
      }
    });
    this.locationId = this.getLocationId;
    this.dataTable = rules;
    this.updateNavItems_(array_teste);
  },
  async mounted() {
    await this.getCollaboratorsData();
    await this.getProjectsData();
  },
  watch: {
    getLocationId: function (val) {
      this.locationId = val;
    },
  },
  methods: {
    ...mapActions([
      "updateNavItems",
      "updateNavCurrentIndex",
      "updateCollaborators",
      "updateCostCenters",
      "setRulesMonth",
    ]),
    async newDatePeriod(newDate) {
      this.rulesMonth = newDate;
      this.setRulesMonth(newDate);
    },
    async getCollaboratorsData() {
      const { data } = await api.get("/findAllCollaborators", {
        params: { locale: this.locationId },
      });
      this.updateCollaborators(data);
    },
    async getProjectsData() {
      const { data } = await api.get("/findAllCostCenters", {
        params: { locale: this.locationId },
      });
      this.updateCostCenters(data);
    },
    updateNavItems_(array_teste) {
      this.updateNavItems(array_teste);
    },
    handleRowClick(row) {
      this.$router.push({
        name: "rule",
        params: { token: row.token },
      });
    },
  },
};
</script>
